import { ref } from 'vue';

export const forecastData = ref({
  forecastday: []
});

export const forecastColors = ref({
  backgroundColor: '#006E63',
  fontColor: '#FFFFFF'
});

export const updateForecastData = (data: any) => {
  if (data && data.forecastday && Array.isArray(data.forecastday)) {
    forecastData.value = data;
  }
};

export const updateForecastColors = (colors: { backgroundColor: string, fontColor: string }) => {
  forecastColors.value = colors;
}; 